<template>
  <div>
    <!-- 标题 -->
    <div class="elasticsearch-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.name }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/elasticsearchMonitor">Elastic Search</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t('alarms.common.monitoringSummary') }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="elasticsearch-top">
      <Row :gutter="16">
        <Col span="6">
        <Select v-model="timeType" filterable @on-change="changeTimeType(timeType)">
          <Option v-for="item in timeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        </Col>
        <Col span="6">
          <Select v-model="cycle" filterable @on-change="changeCycle()">
            <Option v-for="item in cycleList" :value="item.value" :key="item.name">{{item.name}}</Option>
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
        <Col span="6" v-for="(item,index) in list" :key="index">
            <Card :padding="8">
                <p slot="title">{{item.title}}</p>
                <a href="#" slot="extra" @click.prevent="changeFull(item)">
                    <Icon type="ios-expand" size="18"/>
                </a>
                <div :id="item.id" :ref="item.id" style="width:100%;height: 240px;"></div>
            </Card>
        </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal v-model="isShowModal" :mask-closable="false" :closable="false" width="65%">
        <Row>
            <Col span="24">
                <h3>{{lineTitle}}</h3>
                <div id="chart-part" ref="fullChart" style="width:100%; height:420px;"></div>
            </Col>
        </Row>
        <div slot="footer">
            <div>
                <Button @click="cancel">{{$t('alarms.common.close')}}</Button>
            </div>
        </div>
    </Modal>
  </div>
</template>

<script>
  import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'

  export default {
    name: 'Elasticsearch',
    data() {
      return {
        // 放大功能
        lineTitle:'',
        isShowModal: false,
        // 折线图
        list: [{
            id: 'clusterStatus',
            title:this.$t('alarms.elasticSearch.clusterStatus')
        },
        {
            id: 'aWSESClusterIndexWritesBlocked',
            title:this.$t('alarms.elasticSearch.blockWriteRequest')
        },
        {
            id: 'esNodes',
            title:this.$t('alarms.elasticSearch.numberOfNodes')
        },
        {
            id: 'esAutomatedSnapshotFailure',
            title:this.$t('alarms.elasticSearch.automaticSnapshotFailed')
        },
        {
            id: 'esKMSKeyError',
            title:this.$t('alarms.elasticSearch.kMSKeyError')
        },
        {
            id: 'esKMSKeyInaccessible',
            title:this.$t('alarms.elasticSearch.kMSKeyCannotBeAccessed')
        },
        {
            id: 'esCPUUtilization',
            title:this.$t('alarms.elasticSearch.dataNodeCPUUsage')
        },
        {
            id: 'esJVMMemoryPressure',
            title:this.$t('alarms.elasticSearch.dataNodeJVMMemoryPressure')
        },
        {
            id: 'esMasterCPUUtilization',
            title:this.$t('alarms.elasticSearch.cPUUsageOfTheMasterNode')
        },
        {
            id: 'esMasterJVMMemoryPressure',
            title:this.$t('alarms.elasticSearch.JVMMemoryPressureOnTheMasterNode')
        },
        {
            id: 'esFreeStorageSpace',
            title:this.$t('alarms.elasticSearch.dataNodeRemainingStorageSpace')
        }],
        cycle: 300,
        cycleList: [
          {
            name: this.$t('alarms.common.fiveMinutes'),
            value: 5 * 60
          },
          {
            name: this.$t('alarms.common.fifteenMinutes'),
            value: 15 * 60
          },
          {
            name: this.$t('alarms.common.oneHour'),
            value: 1 * 60 * 60
          },
          {
            name: this.$t('alarms.common.sixHour'),
            value: 6 * 60 * 60
          },
          {
            name: this.$t('alarms.common.oneDay'),
            value: 24 * 60 * 60
          }],
        timeType: 0,
        timeList: [],
        id: '',
        accountId: '',
        accountTypeName: '',
        accountName: '',
        region: '',
        // echarts实例
        chartClusterStatus: '',
        chartAWSESFreeStorageSpace: '',
        chartAWSESClusterIndexWritesBlocked: '',
        chartAWSESNodes: '',
        chartAWSESAutomatedSnapshotFailure: '',
        chartAWSESCPUUtilization: '',
        chartAWSESJVMMemoryPressure: '',
        chartAWSESMasterCPUUtilization: '',
        chartAWSESMasterJVMMemoryPressure: '',
        chartAWSESKMSKeyError: '',
        chartAWSESKMSKeyInaccessible: '',
        clusterStatusOption:{},
        aWSESClusterIndexWritesBlockedOption:{},
        esNodesOption:{},
        esAutomatedSnapshotFailureOption:{},
        esKMSKeyErrorOption:{},
        esKMSKeyInaccessibleOption:{},
        esCPUUtilizationOption:{},
        esJVMMemoryPressureOption:{},
        esMasterCPUUtilizationOption:{},
        esMasterJVMMemoryPressureOption:{},
        esFreeStorageSpaceOption:{},
        //AWS数组
        status: [0, 1],
        dataNodeNameList: [],
        masterNodeNameList: [],
        clusterYellowStatus: [],
        clusterGreenStatus: [],
        clusterRedStatus: [],
        freeStorageSpace: [],
        clusterIndexWritesBlocked: [],
        nodes: [],
        automatedSnapshotFailure: [],
        cpuUtilization: [],
        jvmMemoryPressure: [],
        masterCPUUtilization: [],
        masterJVMMemoryPressure: [],
        kmsKeyError: [],
        kmsKeyInaccessible: [],
        xaxisData: []
      }
    },
    mounted: function () {
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartClusterCpuUtilization.resize();
        self.chartClusterRedAndYellowStatus.resize();
      });
    },
    created() {
      this.checkAWSEsStatistics();
    },
    methods: {
      /******************放大********************************/
      changeFull:function(item){
          this.isShowModal=true;
          this.lineTitle=item.title;
          this.$nextTick(() => {
              const chartFul = this.$refs.fullChart;
              if(chartFul){
                  const fullChart = this.$echarts.init(
                      document.getElementById("chart-part")
                  );
                  fullChart.clear();
                  if(item.id=='clusterStatus'){
                      var optionFll = this.clusterStatusOption;
                  }else if(item.id=='aWSESClusterIndexWritesBlocked'){
                      var optionFll = this.aWSESClusterIndexWritesBlockedOption;
                  }else if(item.id=='esNodes'){
                      var optionFll = this.esNodesOption;
                  }else if(item.id=='esAutomatedSnapshotFailure'){
                      var optionFll = this.esAutomatedSnapshotFailureOption;
                  }else if(item.id=='esKMSKeyError'){
                      var optionFll = this.esKMSKeyErrorOption;
                  }else if(item.id=='esKMSKeyInaccessible'){
                      var optionFll = this.esKMSKeyInaccessibleOption;
                  }else if(item.id=='esCPUUtilization'){
                      var optionFll = this.esCPUUtilizationOption;
                  }else if(item.id=='esJVMMemoryPressure'){
                      var optionFll = this.esJVMMemoryPressureOption;
                  }else if(item.id=='esMasterCPUUtilization'){
                      var optionFll = this.esMasterCPUUtilizationOption;
                  }else if(item.id=='esMasterJVMMemoryPressure'){
                      var optionFll = this.esMasterJVMMemoryPressureOption;
                  }else if(item.id=='esFreeStorageSpace'){
                      var optionFll = this.esFreeStorageSpaceOption;
                  }

                  fullChart.setOption(optionFll);
                  window.addEventListener("resize", function() {
                      fullChart.resize();
                  });
              }
          });
      },
      // 模态框取消事件
      cancel() {
          this.isShowModal = false;
      },
      /******************查询********************************/
      // 查询时间范围
      queryTimeHorizon: function () {
        this.$api.cloudWatch.queryTimeHorizon("userName", getCookie(global.cookieName))
          .then(res => {
            this.timeList = res.data;
          })
      },
      // Aws折线图
      checkAWSEsStatistics: function () {
        this.$api.cloudWatch.checkAWSEsStatistics({
          "accountId": this.$route.query.accountId,
          "timeHorizon": this.timeType,
          "period": this.cycle,
          "monitorModule": 14,
          "region": this.$route.query.region,
          "esClusterDomain": this.$route.query.name
        })
          .then(res => {
            this.xaxisData = res.data.xaxisData;
            this.clusterYellowStatus = res.data.clusterYellowStatus;
            this.clusterRedStatus = res.data.clusterRedStatus;
            this.clusterGreenStatus = res.data.clusterGreenStatus;
            this.freeStorageSpace = res.data.freeStorageSpace;
            this.clusterIndexWritesBlocked = res.data.clusterIndexWritesBlocked;
            this.nodes = res.data.nodes;
            this.automatedSnapshotFailure = res.data.automatedSnapshotFailure;
            this.cpuUtilization = res.data.cpuUtilization;
            this.jvmMemoryPressure = res.data.jvmMemoryPressure;
            this.masterCPUUtilization = res.data.masterCPUUtilization;
            this.masterJVMMemoryPressure = res.data.masterJVMMemoryPressure;
            this.kmsKeyError = res.data.kmsKeyError;
            this.kmsKeyInaccessible = res.data.kmsKeyInaccessible;
            // 数据节点名称
            if (res.data.freeStorageSpace.length > 0) {
              for (let i = 0; i < res.data.freeStorageSpace.length; i++) {
                this.dataNodeNameList.push(res.data.freeStorageSpace[i].name);
              }
            }
            // 主节点名称
            if (res.data.masterCPUUtilization.length > 0) {
                for (let i = 0; i < res.data.masterCPUUtilization.length; i++) {
                    this.masterNodeNameList.push(res.data.masterCPUUtilization[i].name);
                }
            }
            this.allAws();
          })
      },
      changeTimeType: function () {
        this.checkAWSEsStatistics();
      },
      // 切换周期
      changeCycle:function(){
        this.checkAWSEsStatistics();
      },
      /******************所有折线图********************************/
      allAws: function () {
        this.clusterStatusLine();
        this.awsESClusterIndexWritesBlockedLine();
        this.awsESAutomatedSnapshotFailureLine();
        this.awsESNodesLine();
        this.awsESCPUUtilizationLine();
        this.awsESJVMMemoryPressureLine();
        this.awsESMasterJVMMemoryPressureLine();
        this.awsESMasterCPUUtilizationLine();
        this.awsESFreeStorageSpaceLine();
        this.awsESKMSKeyErrorLine();
        this.awsESKMSKeyInaccessibleLine();

      },
      /*************折线图*****************************/
      /**
       *  AWS ES 集群状态
       */
      clusterStatusLine: function () {
        this.chartClusterStatus = this.$echarts.init(document.getElementById("clusterStatus"));
        this.clusterStatusOption={
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            x: 'right',
            y: '10px',
            data: [this.$t('alarms.elasticSearch.green'), this.$t('alarms.elasticSearch.yellow'), this.$t('alarms.elasticSearch.red')]
          },
          series: [
            {
              name: this.$t('alarms.elasticSearch.red'),
              type: 'line',
              data: this.clusterRedStatus,
              color: 'red',
              areaStyle: {},
            },
            {
              name: this.$t('alarms.elasticSearch.yellow'),
              type: 'line',
              data: this.clusterYellowStatus,
              color: 'yellow',
              areaStyle: {},
            },
            {
              name: this.$t('alarms.elasticSearch.green'),
              type: 'line',
              data: this.clusterGreenStatus,
              color: 'green',
              areaStyle: {},
            },
          ],
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: ['', this.$t('alarms.elasticSearch.green'), this.$t('alarms.elasticSearch.yellow'), this.$t('alarms.elasticSearch.red')]
            }
          ]
        }
        this.chartClusterStatus.setOption(this.clusterStatusOption)
      },
      /**
       *  AWS ES 群集正在阻止写入请求
       */
      awsESClusterIndexWritesBlockedLine: function () {
        this.chartAWSESClusterIndexWritesBlocked = this.$echarts.init(document.getElementById("aWSESClusterIndexWritesBlocked"));
        this.aWSESClusterIndexWritesBlockedOption={
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6337cf'
              }
            }
          },
          // 阻止写入请求
          legend: {
            x: 'right',
            y: '10px',
            data: [this.$t('alarms.elasticSearch.blockWriteRequest')]
          },
          series: [{
            name: this.$t('alarms.elasticSearch.blockWriteRequest'),
            type: 'line',
            data: this.clusterIndexWritesBlocked,
            color: '#6337cf',
            areaStyle: {},
          }],
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.status
            }
          ]
        }
        this.chartAWSESClusterIndexWritesBlocked.setOption(this.aWSESClusterIndexWritesBlockedOption)
      },
      /**
       *  AWS ES 节点数量
       */
      awsESNodesLine: function () {
        this.chartAWSESNodes = this.$echarts.init(document.getElementById("esNodes"));
        this.esNodesOption={
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#64ae2a'
              }
            }
          },
          // 节点数量
          legend: {
            x: 'right',
            y: '10px',
            data: [this.$t('alarms.elasticSearch.numberOfNodes')]
          },
          series: [{
            name: this.$t('alarms.elasticSearch.numberOfNodes'),
            type: 'line',
            data: this.nodes,
            color: '#64ae2a',
            areaStyle: {},
          }],
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitNumber: 1,
            }
          ]
        }
        this.chartAWSESNodes.setOption(this.esNodesOption)
      },
      /**
       *  AWS ES 自动快照失败
       */
      awsESAutomatedSnapshotFailureLine: function () {
        this.chartAWSESAutomatedSnapshotFailure = this.$echarts.init(document.getElementById("esAutomatedSnapshotFailure"));
        this.esAutomatedSnapshotFailureOption={
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#33acac'
              }
            }
          },
          // 自动快照失败
          legend: {
            x: 'right',
            y: '10px',
            data: [this.$t('alarms.elasticSearch.automaticSnapshotFailed')]
          },
          series: [{
            name: this.$t('alarms.elasticSearch.automaticSnapshotFailed'),
            type: 'line',
            data: this.automatedSnapshotFailure,
            color: '#33acac',
            areaStyle: {},
          }],
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.status
            }
          ]
        }
        this.chartAWSESAutomatedSnapshotFailure.setOption(this.esAutomatedSnapshotFailureOption)
      },
      /**
       *  AWS ES KMS密钥错误
       */
      awsESKMSKeyErrorLine: function () {
        this.chartAWSESKMSKeyError = this.$echarts.init(document.getElementById("esKMSKeyError"));
        this.esKMSKeyErrorOption={
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          // KMS 密钥错误
          legend: {
            x: 'right',
            y: '10px',
            data: [this.$t('alarms.elasticSearch.kMSKeyError')]
          },
          series: [{
            name: this.$t('alarms.elasticSearch.kMSKeyError'),
            type: 'line',
            data: this.kmsKeyError,
            color: '#6a7985',
            areaStyle: {},
          }],
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.status
            }
          ]
        }
        this.chartAWSESKMSKeyError.setOption(this.esKMSKeyErrorOption)
      },
      /**
       *  AWS ES KMS密钥无法访问
       */
      awsESKMSKeyInaccessibleLine: function () {
        this.chartAWSESKMSKeyInaccessible = this.$echarts.init(document.getElementById("esKMSKeyInaccessible"));
        this.esKMSKeyInaccessibleOption={
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          // KMS 密钥错误
          legend: {
            x: 'right',
            y: '10px',
            data: [this.$t('alarms.elasticSearch.kMSKeyCannotBeAccessed')]
          },
          series: [{
            name: this.$t('alarms.elasticSearch.kMSKeyCannotBeAccessed'),
            type: 'line',
            data: this.kmsKeyInaccessible,
            color: '#6a7985',
            areaStyle: {},
          }],
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.status
            }
          ]
        }
        this.chartAWSESKMSKeyInaccessible.setOption(this.esKMSKeyInaccessibleOption)
      },
      /**
       * AWS ES 数据节点CPU使用率
       */
      awsESCPUUtilizationLine: function () {
        this.chartAWSESCPUUtilization = this.$echarts.init(document.getElementById("esCPUUtilization"));
        this.esCPUUtilizationOption={
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            x: 'right',
            y: '10px',
            data: this.dataNodeNameList
          },
          series: this.cpuUtilization,
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              splitNumber: 4,
              type: 'value'
            }
          ]
        }
        this.chartAWSESCPUUtilization.setOption(this.esCPUUtilizationOption)
      },
      /**
       * AWS ES 数据节点 JVM 内存压力
       */
      awsESJVMMemoryPressureLine: function () {
        this.chartAWSESJVMMemoryPressure = this.$echarts.init(document.getElementById("esJVMMemoryPressure"));
        this.esJVMMemoryPressureOption={
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          // 集群平均CPU利用率
          legend: {
            x: 'right',
            y: '10px',
            data: this.dataNodeNameList
          },
          series: this.jvmMemoryPressure,
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              splitNumber: 4,
              type: 'value'
            }
          ]
        }
        this.chartAWSESJVMMemoryPressure.setOption(this.esJVMMemoryPressureOption)
      },
      /**
       * AWS ES 主节点CPU使用率
       */
      awsESMasterCPUUtilizationLine: function () {
        this.chartAWSESMasterCPUUtilization = this.$echarts.init(document.getElementById("esMasterCPUUtilization"));
        this.esMasterCPUUtilizationOption={
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            x: 'right',
            y: '10px',
            data: this.masterNodeNameList
          },
          series: this.masterCPUUtilization,
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              splitNumber: 4,
              type: 'value'
            }
          ]
        }
        this.chartAWSESMasterCPUUtilization.setOption(this.esMasterCPUUtilizationOption)
      },
      /**
       * AWS ES 主节点JVM内存压力
       */
      awsESMasterJVMMemoryPressureLine: function () {
        this.chartAWSESMasterJVMMemoryPressure = this.$echarts.init(document.getElementById("esMasterJVMMemoryPressure"));
        this.esMasterJVMMemoryPressureOption={
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            x: 'right',
            y: '10px',
            data: this.masterNodeNameList
          },
          series: this.masterJVMMemoryPressure,
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              splitNumber: 4,
              type: 'value'
            }
          ]
        }
        this.chartAWSESMasterJVMMemoryPressure.setOption(this.esMasterJVMMemoryPressureOption)
      },
      /**
       * 数据节点剩余空间使用率 (百分比)
       */
      awsESFreeStorageSpaceLine: function () {
        this.chartAWSESFreeStorageSpace = this.$echarts.init(document.getElementById("esFreeStorageSpace"));
        this.esFreeStorageSpaceOption={
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            x: 'right',
            y: '10px',
            data: this.dataNodeNameList
          },
          series: this.freeStorageSpace,
          grid: {
            top:'20%',
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xaxisData.map(function (str) {
                return str.replace(' ', '\n')
              })
            }
          ],
          yAxis: [
            {
              splitNumber: 4,
              type: 'value'
            }
          ]
        }
        this.chartAWSESFreeStorageSpace.setOption(this.esFreeStorageSpaceOption)
      },
      /********************************/
      // 点击返回详情页
      ipAddress: function () {
        this.id = this.$route.query.id;
        this.accountId = this.$route.query.accountId;
        this.region = this.$route.query.region;
        this.accountTypeName = this.$route.query.accountTypeName;
        this.accountName = this.$route.query.accountName;
        this.name = this.$route.query.name;
        this.$router.push({
          path: '/monitor/elasticsearchDetail/',
          query: {
            id: this.id,
            accountId: this.accountId,
            region: this.region,
            accountTypeName: this.accountTypeName,
            accountName: this.accountName,
            name: this.name
          }
        });
      }
    }
  }
</script>

<style scoped>
  .elasticsearch-title {
    width: 100%;
    font-size: 13px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px 0px 15px 4px;
    font-weight: 600;
  }

  .ivu-col-span-6 {
    margin-bottom: 20px;
  }

  .elasticsearch-top {
    width: 100%;
    height: 53px;
  }

  .ivu-breadcrumb {
    font-size: 13px;
    font-weight: 600;
    color: #515a6e;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitor/es/elasticsearch_dashboard/Elasticsearch.vue